/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Contractid2Inputs */

const en__field_contractid2 = /** @type {(inputs: _Field_Contractid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contract`)
};

const de__field_contractid2 = /** @type {(inputs: _Field_Contractid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertrag`)
};

/**
* | output |
* | --- |
* | "Contract" |
*
* @param {_Field_Contractid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_contractid2 = /** @type {((inputs?: _Field_Contractid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Contractid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_contractid2(inputs)
	return de__field_contractid2(inputs)
});
export { _field_contractid2 as "_field_contractID" }